export const allPlanLoading = ({store}) => store.allPlanReducer.loading;

export const allPlanError =  ({store})  => store.allPlanReducer.error;

export const allPlanData =  ({store})  => store.allPlanReducer.data;